/* Request Items Statuses */
const EXISTING_PUBLISHERS = 'EXISTING_PUBLISHERS';

/* Booklist Status Filter Types */
const BOOKLISTS_ALL = 'ALL';

export default {
    defaultBook:{
        id: new Date().getTime(),
        title:'',
        vbid:'',
        isbn:[],
        author:'',
        publisher:'',
        status:'',
        course:null,
        added:new Date().getTime(),
        last_modified:new Date().getTime(),
        companies_with_status:{}
    },
    defaultBooklist:{
        name:'',
        color: 'SANGRIA',
        books:[],
        updated_at: new Date().getTime()
    },
    defaultBooklistPersistProps:{
        page: 1,
        size: 25,
        search: '',
        status: BOOKLISTS_ALL,
        sort: '',
        dir: ''
    },
    defaultRequestPagePersistProps:{
        page: 1,
        size: 25,
        search: '',
        status: EXISTING_PUBLISHERS,
        sort: '',
        dir: '',
        institution: '',
        publisher: ''
    },
    defaultCompany:{
        id: 0,
        parent_id: null,
        name:''
    },
    defaultCourse: {
        requested_title_id: null,
        company_id: null,
        course_code: '',
        section_number: 0,
        enrollment: 0,
        content_deadline: '',
        launch_date: ''
    }
};